import React from "react";
import { DisplayHours } from "components/display/hours";

const HoursCell = ({ getValue }) => {
  return <DisplayHours value={getValue()} precision={0} format={true} />;
};

const TotalHoursCell = (key, { precision = 0 } = {}) => {
  return (totals) => (
    <DisplayHours value={totals[key] ?? 0} precision={precision} format={true} />
  );
};

export { HoursCell, TotalHoursCell };
